export const navs_zh = {
  title: '开发者文档',
  array: [
    {
      key: '1',
      title: '平台介绍',
      // route: '/introductions',
      array: [
        {
          key: '1_1',
          title: '操作说明',
          route: '/introductions',
          array: [],
        },
      ],
    },
    {
      key: '2',
      title: '云对云',
      description: '设备连接青萍服务器，客户通过 API 从青萍服务器获取数据。',
      array: [
        {
          key: '2_1',
          title: '规范说明',
          route: '/cloud-to-cloud/specification-guidelines',
          array: [],
        },
        {
          key: '2_2',
          title: '产品接入指引',
          route: '/cloud-to-cloud/product-access-guidelines',
          // array: [
          //   {
          //     key: '2_6_2',
          //     title: '青萍空气检测仪',
          //     route: '/main/guide/snow',
          //   },
          //   {
          //     key: '2_6_8',
          //     title: '青萍空气检测仪 Lite',
          //     route: '/main/guide/dany',
          //   },
          //   {
          //     key: '2_6_3',
          //     title: '青萍商用温湿度/气压计',
          //     route: '/main/guide/pheasant',
          //   },

          //   {
          //     key: '2_6_6',
          //     title: '青萍商用温湿度计 E',
          //     route: '/main/bussiness/frog',
          //   },
          // ],
        },
        {
          key: '2_3',
          title: 'OAuth 2.0 认证',
          route: '/cloud-to-cloud/oauth',
          array: [],
        },
        {
          key: '2_4',
          title: '开放接口',
          route: '/cloud-to-cloud/open-apis',
          array: [],
        },
        {
          key: '2_5',
          title: '数据推送',
          route: '/cloud-to-cloud/data-push',
          array: [],
        },
        {
          key: '2_6',
          title: 'SDK',
          route: '/cloud-to-cloud/sdk',
          array: [],
        },
      ],
    },

    {
      key: '3',
      title: '私有化',
      description: '设备直接连接客户指定的服务器。',
      array: [
        {
          key: '3_1',
          title: '接入说明',
          route: '/private/access-instructions',
          array: [],
        },
        {
          key: '3_2',
          title: '通信协议',
          array: [

            {
              key: '3_2_1',
              title: '公有 MQTT JSON 通信协议',
              route: '/private/communication-protocols/public-mqtt-json',
              array: [],
            },
            {
              key: '3_2_2',
              title: '公有 MQTT HEX 通信协议',
              route: '/private/communication-protocols/public-mqtt-hex',
              array: [],
            },
            {
              key: '3_2_3',
              title: '商用温湿度（气压）计（S）LoRaWAN Modbus 协议',
              route: '/private/communication-protocols/temp-rh-monitor/lorawan-modbus',
              array: [],
            },
            {
              key: '3_2_5',
              title: '二氧化碳和温湿度检测仪 LoRaWAN Modbus 协议',
              route: '/private/communication-protocols/co2-temp-rh-monitor/lorawan-modbus',
              array: [],
            },
            {
              key: '3_2_6',
              title: '室内环境检测仪 LoRaWAN Modbus 协议',
              route: '/private/communication-protocols/indoor-environment-monitor/lorawan-modbus',
              array: [],
            },
          ],
        },
        {
          key: '3_3',
          title: '其他',
           array: [
            {
              key: '3_3_1',
              title: '空气检测仪接入说明',
              route: '/private/air-monitor/access-instructions',
              array: [],
            },
          ],
        }
      ],
    },
  
  ],
}

export const navs_en = {
  title: 'Docs',
  array: [
    {
      key: '1',
      title: 'Platform Introductions',
      array: [
        {
          key: '1_1',
          title: 'Introduction',
          route: '/introductions',
          array: [],
        },
      ],
    },
    {
      key: '2',
      title: 'Cloud to Cloud',
      description: 'Devices connect to Qingping server, customers retrieve data from Qingping server via API.',
      array: [
        {
          key: '2_1',
          title: 'Specification Guidelines',
          route: '/cloud-to-cloud/specification-guidelines',
          array: [],
        },
        {
          key: '2_2',
          title: 'Product Access Guidelines',
          route: '/cloud-to-cloud/product-access-guidelines',
          array: [],
          // array: [
          //   {
          //     key: '2_6_2',
          //     title: 'Qingping Air Monitor',
          //     route: '/main/guide/snow',
          //   },
          //   {
          //     key: '2_6_8',
          //     title: 'Qingping Air Monitor Lite',
          //     route: '/main/guide/dany',
          //   },
          //   {
          //     key: '2_6_3',
          //     title: 'Qingping Temp & RH Barometer',
          //     route: '/main/guide/pheasant',
          //   },
          //   {
          //     key: '2_6_6',
          //     title: 'Qingping Temp & RH Monitor Pro E',
          //     route: '/main/bussiness/frog',
          //   },
          // ],
        },
        {
          key: '2_3',
          title: 'OAuth 2.0 Authentication',
          route: '/cloud-to-cloud/oauth',
          array: [],
        },
        {
          key: '2_4',
          title: 'Open APIs',
          route: '/cloud-to-cloud/open-apis',
          array: [],
        },
        {
          key: '2_5',
          title: 'Data Push',
          route: '/cloud-to-cloud/data-push',
          array: [],
        },
        {
          key: '2_6',
          title: 'SDK',
          route: '/cloud-to-cloud/sdk',
          array: [],
        },
      ],
    }, 
    {
      key: '3',
      title: 'Private Access',
      description: 'Devices connect directly to customer-specified servers.',
      array: [
        {
          key: '3_1',
          title: 'Access Instructions',
          route: '/private/access-instructions',
          array: [],
        },
        {
          key: '3_2',
          title: 'Communication Protocols',
          array: [
            {
              key: '3_2_1',
              title: 'Public MQTT JSON Protocol',
              route: '/private/communication-protocols/public-mqtt-json',
              array: [],
            },
            {
              key: '3_2_2',
              title: 'Public MQTT HEX Protocol',
              route: '/private/communication-protocols/public-mqtt-hex',
              array: [],
            },
            {
              key: '3_2_3',
              title: 'Temp & RH Monitor (Barometer) Pro (S) LoRaWAN Modbus Protocol',
              route: '/private/communication-protocols/temp-rh-monitor/lorawan-modbus',
              array: [],
            },
            {
              key: '3_2_4',
              title: 'CO2 & Temp & RH Monitor LoRaWAN Modbus Protocol',
              route: '/private/communication-protocols/co2-temp-rh-monitor/lorawan-modbus',
              array: [],
            },
            {
              key: '3_2_5',
              title: 'Indoor Environment Monitor LoRaWAN Modbus Protocol',
              route: '/private/communication-protocols/indoor-environment-monitor/lorawan-modbus',
              array: [],
            },
          ],
        },
        {
          key: '3_3',
          title: 'Others',
           array: [
            {
              key: '3_3_1',
              title: 'Air Monitor Access Instructions',
              route: '/private/air-monitor/access-instructions',
              array: [],
            },
          ],
        }
      ],
    },
  ],
}
